"use client";

export default function StoreCard({ store, onClick }) {

  const storeUrl = store.link || store.url || store.website || "";

  return (
    <div
      onClick={() => onClick(store)}
      className="h-full flex flex-col bg-white dark:bg-zinc-800 rounded-2xl shadow-md border overflow-hidden hover:shadow-xl hover:-translate-y-1 transition cursor-pointer p-4 text-center"
    >
      <div className="w-full h-32 bg-zinc-100 rounded-lg mb-3 flex items-center justify-center overflow-hidden">
        <img
          src={store.photo || "/store-placeholder.jpg"}
          alt={store.storeName}
          className="h-full object-contain"
        />
      </div>

      <div className="flex-1 flex flex-col">
        <h3 className="font-semibold text-lg line-clamp-1">
          {store.storeName}
        </h3>

        <p className="text-sm text-zinc-500 line-clamp-2">
          {store.storeDescription || "No description"}
        </p>

        {store.phone && (
          <div className="mt-3 text-xs text-zinc-500">
            Tel:{" "}
            <a
              href={`tel:${store.phone}`}
              onClick={(e) => e.stopPropagation()}
              className="text-[#00778B]"
            >
              {store.phone}
            </a>
          </div>
        )}

        {storeUrl && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              window.open(storeUrl, "_blank");
            }}
            className="mt-2 text-xs text-[#00778B] hover:underline"
          >
            Show Catalog
          </button>
        )}
      </div>
    </div>
  );
}